import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ProfileModel } from "../../shared/models/profile.model";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  @Input() profile: ProfileModel;
  userFullName: string;

  constructor(private readonly authService: AuthService) { }

  ngOnInit(): void {
    this.userFullName = this.authService.userFullName;
  }

}
